// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__itfiB","Loading__Svg":"Loading_Loading__Svg__8w-qO","spinner":"Loading_spinner__VyDi1"};